export default {
  getList: (specifiedKey) => ['idp-client-list-' + specifiedKey],
};
